import { useFeatureFlag } from '@moda/portal-stanchions';
import { TWENTY_TWO_DAYS } from '../../../constants';
import { OrderItem } from '../../../hooks/useOrder';

export const ReturnBasedOnPromo = (item: OrderItem) => {
  const updatedReturnPolicyText = useFeatureFlag('updated-return-policy-text', [
    { default: false },
    { if: true, then: true }
  ]);
  const shippedOn = item?.attributes?.shippedOn;
  if (!shippedOn && !item?.attributes?.promotionApplicableMessage) return false;

  const shippedOnDate = shippedOn && new Date(shippedOn);
  // We calculate this date by shipped day + 14 business shipping days
  // *Sunday is not a shipping day, so we have shippedOn + 16(14+two sundays) = 22;
  const shippedPlus22Days =
    shippedOnDate && shippedOnDate.setDate(shippedOnDate.getDate() + TWENTY_TWO_DAYS);
  const nowDate = new Date().getTime();
  const notInRange = shippedPlus22Days && nowDate > shippedPlus22Days;
  return updatedReturnPolicyText && notInRange;
};
